import React from "react";

import { Divider } from "@mui/material";
import { DiaryContainer } from "../../shared/DiaryContainer";
import { DiaryHeader } from "../../shared/DiaryHeader";
import { ResourceViewerOptions } from "Util/enums";

import { useOperationDespatchContext } from "../../../../contexts/DespatchContext";
import { DespatchContainer } from "./style";
import { ResourceTeamViewer, ResourceTaskViewer } from "./subcomponent/Viewers";

type Props = {
  dataPermission: {
    members: boolean;
    teams: boolean;
    tasks: boolean;
    equipments: boolean;
    storageBoxes: boolean;
  };
};

export const DiaryResourcesView = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { dataPermission } = props;
  const { selectedOption } = useOperationDespatchContext();

  const renderViewer = () => {
    if (ResourceViewerOptions.ORDER === selectedOption)
      return <ResourceTaskViewer dataPermission={dataPermission} />;

    if (ResourceViewerOptions.TEAM === selectedOption)
      return <ResourceTeamViewer dataPermission={dataPermission} />;

    return null;
  };

  return (
    <DiaryContainer ref={ref}>
      <DiaryHeader style={{ paddingBottom: "16px" }} />

      <DespatchContainer>
        <Divider />
        {renderViewer()}
      </DespatchContainer>
    </DiaryContainer>
  );
});
